<template>
  <div v-loading="loading">
    <div class="flex items-center justify-between mt-2">
      <page-header
        heading="Account Security"
        breadcrumb="Settings  >>  Account Security"
        :back="true"
      />
    </div>
    <div class="bg-white rounded p-4 mt-8 min-h-screen">
      <password-settings />
      <two-factor-authentication />
    </div>
  </div>
</template>

<script>
import PageHeader from "../../PageHeader.vue";
import PasswordSettings from "./PasswordSettings.vue";
import TwoFactorAuthentication from "./TwoFactorAuthentication.vue";
export default {
  components: {
    PageHeader,
    PasswordSettings,
    TwoFactorAuthentication,

  },
  data() {
    return {
      bookings: [],
      loading: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style></style>
